module.exports = __webpack_public_path__ + "img/VU.f658c946.svg";